export const DOMAIN_COLUMN_MIN_WIDTH = "130px";
export const NOT_AVAILABLE_VALUE = "N/A";
